var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFaceon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2636_999)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(2 2)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9987 21.9997C20.3945 21.9997 19.0213 21.4285 17.8789 20.2861C16.7365 19.1438 16.1654 17.7705 16.1654 16.1663C16.1654 14.5622 16.7365 13.1889 17.8789 12.0465C19.0213 10.9042 20.3945 10.333 21.9987 10.333C23.6029 10.333 24.9761 10.9042 26.1185 12.0465C27.2609 13.1889 27.832 14.5622 27.832 16.1663C27.832 17.7705 27.2609 19.1438 26.1185 20.2861C24.9761 21.4285 23.6029 21.9997 21.9987 21.9997ZM10.332 33.6663V29.583C10.332 28.7566 10.5449 27.9973 10.9708 27.3051C11.3966 26.6129 11.9615 26.084 12.6654 25.7184C14.1723 24.965 15.7036 24.4001 17.2591 24.0238C18.8147 23.6476 20.3945 23.459 21.9987 23.458C23.6029 23.457 25.1827 23.6456 26.7383 24.0238C28.2938 24.402 29.8251 24.9669 31.332 25.7184C32.0369 26.083 32.6022 26.6119 33.0281 27.3051C33.4539 27.9983 33.6663 28.7576 33.6654 29.583V33.6663H10.332Z",
    fill: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2636_999",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2636_999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2636_999",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFaceon);
export default __webpack_public_path__ + "static/media/ic_faceon.f4a984e21cb3cf190c0c0ac488fe911b.svg";
export { ForwardRef as ReactComponent };